(function() {
	/**
	 * Render Homepage
	 * @param {object} props - The Routing context
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderHome = function(props) {
		var today = new Date();
		var dd = String(today.getDate()).padStart(2, '0');
		var mm = String(today.getMonth() + 1).padStart(2, '0');
		var yyyy = today.getFullYear();
		today = yyyy + '-' + mm + '-' + dd;
		var model = {
			element: null,
			template: 'templates/home.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				navRaw: null,
				pageRaw: null,
				home: null,
				news: null
			}
		};
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=homepage&depth=3'),
			ejs.preloadTemplate(model.template)
		)
		.then(function(pageRawXhr, tmplHome) {
			var pageRaw = Array.isArray(pageRawXhr) && pageRawXhr.length ? pageRawXhr[0] : (pageRawXhr || {});
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var now = new Date();
			var container;
			model.data.pageRaw = pageRaw;
			model.data.home = WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {};
			container = model.data.home.container || [];
			// lookup of 'News Container' items
			var newsContainers = container.filter(function(component) {
				return component.system_type === 'news_container' && (component.container || []).length === 0 && ((component.news_categories || []).length > 0 || (component.news_tag || []).length > 0 || (component.quelix_searchstring));
				// return component.system_type === 'news_container';
			});
			// lookup of 'News-Ticker Container' items
			var newsTickerContainers = container.filter(function(component) {
				return component.system_type === 'newsticker_container' && (component.container || []).length === 0 && (component.news_categories || []).length > 0;
			});
			// lookup of 'Project Container' items
			var projectContainers = container.filter(function(component) {
				return component.system_type === 'project_container' && (component.container || []).length === 0 && (component.project_categories || []).length > 0;
			});
			// lookup of 'Appointment Container' items
			var appointmentContainers = container.filter(function(component) {
				return component.system_type === 'appointment_container' && (component.container || []).length === 0 && (component.appointment_categories || []).length > 0;
			});
			// lookup of 'Foreign Project ID' News
			var newsForeignProjectID = newsContainers.map(function(component) {
				var customNewsProjectID = (component.foreign_project_id || '');
				if (customNewsProjectID.length) {
					return customNewsProjectID;
				}
			});
			// lookup of 'Foreign Project ID' Projects
			var projectForeignProjectID = projectContainers.map(function(component) {
				var customProjectProjectID = (component.foreign_project_id || '');
				if (customProjectProjectID.length) {
					return customProjectProjectID;
				}
			});
			// lookup of 'Foreign Project ID' Appointments
			var appointmentForeignProjectID = appointmentContainers.map(function(component) {
				var customAppointmentProjectID = (component.foreign_project_id || '');
				if (customAppointmentProjectID.length) {
					return customAppointmentProjectID;
				}
			});
			// lookup of 'Quelix Searchstring'
			var newsQuelixSearchstring = newsContainers.map(function(component) {
				var customNewsQuelixSearchstring = (component.quelix_searchstring || '');
				if (customNewsQuelixSearchstring.length) {
					return customNewsQuelixSearchstring;
				}
			});
			// News KK request urls
			var newsRequests = newsContainers.map(function(component) {
				var query = ['?system.type=news'];
				var categories = (component.news_categories || []).map(function(category) {
					return category.codename;
				});
				var tags = (component.news_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.news_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// tags
				if (tags.length) {
					query.push('elements.news_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				// sort order
				query.push('order=elements.date[desc]');
				query.push('limit=3');
				return query.join('&');
			});
			// News-Ticker KK request urls
			var newsTickerRequests = newsTickerContainers.map(function(component) {
				var query = ['?system.type=news'];
				var categories = (component.news_categories || []).map(function(category) {
					return category.codename;
				});
				var tags = (component.news_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.news_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// tags
				if (tags.length) {
					query.push('elements.news_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				// sort order
				query.push('order=elements.date[desc]');
				query.push('limit=' + limit);
				return query.join('&');
			});
			// Projects KK request urls
			var projectRequests = projectContainers.map(function(component) {
				var query = ['?system.type=project_item'];
				var categories = component.project_categories.map(function(category) {
					return category.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.project_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// sort order
				query.push('order=elements.date_from[desc]');
				query.push('limit=3');
				return query.join('&');
			});
			// Appointments KK request urls
			var appointmentRequests = appointmentContainers.map(function(component) {
				var query = ['?system.type=appointment_item'];
				var categories = component.appointment_categories.map(function(category) {
					return category.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.appointment_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				query.push(['elements.date_from[gte]=', now.getFullYear(), '-', String('0' + (now.getMonth() + 1)).slice(-2), '-', String('0' + now.getDate()).slice(-2)].join(''));
				// sort order
				query.push('order=elements.date_from[asc]');
				query.push('limit=2');
				return query.join('&');
			});
			/* Fetch other needed things here: News, Publications... Register it as collections */
			// mapping list is the list of codenames that corresponds to the list of the dynamic additional requests that will follow here
			var mapping = newsContainers.concat(newsTickerContainers, appointmentContainers, projectContainers).map(function(component) {
				return {
					codename: (component.system_codename || ''),
					type: 'kk'
				};
			});
			// insert foreign project Id if present in news, project or appointment container
			var req = newsRequests.concat(newsTickerRequests, appointmentRequests, projectRequests).map(function(kkUrl) {
				if (/system.type=news/i.test(kkUrl)) {
					if (typeof newsQuelixSearchstring[0] != 'undefined') {
						return WebBaseAprovLV.Utils.getSearchData(newsQuelixSearchstring[0]);
					} else {
						return WebBaseAprovLV.Utils.getKKData(kkUrl, (newsForeignProjectID[0] || []));
					}
				} else if (/system.type=appointment_item/i.test(kkUrl)) {
					return WebBaseAprovLV.Utils.getKKData(kkUrl, (appointmentForeignProjectID[0] || []));
				} else if (/system.type=project_item/i.test(kkUrl)) {
					return WebBaseAprovLV.Utils.getKKData(kkUrl, (projectForeignProjectID[0] || []));
				} else {
					return WebBaseAprovLV.Utils.getKKData(kkUrl);
				}
			});
			if (newsTickerContainers.length) {
				mapping.push({
					codename: 'js-breaking-news-ticker',
					type: 'script'
				});
				req.push((function() {
					return WebBaseAprovLV.Utils.fetchAsync({
						dataType: 'script'
					})('js-modules/thirdparty/breaking-news-ticker.min.js?v=' + WebBaseAprovLV.version.template);
				})());
			}
			req.push(mapping);
			return $.when.apply($, req);
		}).then(function() {
			var args = Array.prototype.slice.call(arguments);
			var mapping = args.pop();
			var collections = {};
			args.forEach(function(item, i) {
				var m = mapping.length >= i ? mapping[i] : {};
				var codename = m.codename || '';
				var type = m.type || '';
				if (codename.length && item.length && type !== 'script') {
					collections[codename] = {
						raw: (item || []).length ? item[0] : [],
						viewmodel: (item || []).length > 0 && (item[0].items || []).length > 0 ? (WebBaseAprovLV.Utils.getKKViewModel(item[0]) || []) : []
					};
				}
			});
			model.element = $('#content');
			model.data = $.extend(model.data, {
				collections: collections
			});
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).then(function(ejsmodel) {
			var $newsTicker = $('.js-news-ticker');
			if ($newsTicker.length && $newsTicker.breakingNews) {
				$newsTicker.breakingNews();
			}
			return ejsmodel;
		}).promise();
	};
})();
